import { render, staticRenderFns } from "./ShortcutsTask.vue?vue&type=template&id=e1ee931e"
import script from "./ShortcutsTask.vue?vue&type=script&lang=js"
export * from "./ShortcutsTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports